import Modal from "common/Modal/Modal";
import Title from "common/Typography/Title";
import React from "react";
import useWatchlist from "features/watchlist/common/useWatchlist";
import styled from "styled-components";
import AntExclamationCircleOutlined from "@ant-design/icons/ExclamationCircleOutlined";
import { MarketToRemove } from "types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface RemoveMarketWarningModalProps {
  marketToRemove?: MarketToRemove;
  resetMarket: () => void;
}

const RemoveFromWatchlistModal = ({
  marketToRemove,
  resetMarket,
}: RemoveMarketWarningModalProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.WATCHLIST);
  const { removeMarket, removeFromWatchlistLoading } = useWatchlist();
  const modalText = t("modal.remove.message", {
    symbol: marketToRemove?.symbol,
    exchange: marketToRemove?.exchange,
  });

  return (
    <Modal
      title={false}
      open={!!marketToRemove}
      okText={t("modal.remove.yes")}
      okButtonProps={{ loading: removeFromWatchlistLoading, danger: true }}
      cancelText={t("modal.remove.no")}
      onOk={() =>
        marketToRemove &&
        removeMarket(
          marketToRemove.symbol,
          marketToRemove.exchange,
          resetMarket
        )
      }
      onCancel={resetMarket}
      width={450}
    >
      <ModalContent>
        <ExclamationCircleOutlined />
        <Title level={3}>{modalText}</Title>
      </ModalContent>
    </Modal>
  );
};

export default RemoveFromWatchlistModal;

const ModalContent = styled.div`
  display: flex;
  padding: 12px 12px 0;
`;
const ExclamationCircleOutlined = styled(AntExclamationCircleOutlined)`
  color: ${(p) => p.theme.colors.gold};
  margin-right: 12px;
  font-size: 24px;
`;
